module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiExt.9984daf.ttf";